export enum PredictionTypeEnum {
  Win = 'win',
  Draw = 'draw',
}

export enum ScoreEnum {
  OneZero = '1-0',
  TwoZero = '2-0',
  TwoOne = '2-1',
  ThreeZero = '3-0',
  ThreeOne = '3-1',
  ThreeTwo = '3-2',
  FourZero = '4-0',
  FourOne = '4-1',
  FourTwo = '4-2',
  FourThree = '4-3',
  FiveAndMore = '5 and more',

  ZeroZero = '0-0',
  OneOne = '1-1',
  TwoTwo = '2-2',
  ThreeThree = '3-3',
  FourFour = '4-4',
  FiveFiveMore = '5-5 and more'
}

export const getValueByPredictionType = (type: PredictionTypeEnum): ScoreEnum[] => {
  switch (type) {
    case PredictionTypeEnum.Win:
      return [
        ScoreEnum.OneZero,
        ScoreEnum.TwoZero,
        ScoreEnum.TwoOne,
        ScoreEnum.ThreeZero,
        ScoreEnum.ThreeOne,
        ScoreEnum.ThreeTwo,
        ScoreEnum.FourZero,
        ScoreEnum.FourOne,
        ScoreEnum.FourTwo,
        ScoreEnum.FourThree,
        ScoreEnum.FiveAndMore,
      ]

    case PredictionTypeEnum.Draw:
      return [
        ScoreEnum.ZeroZero,
        ScoreEnum.OneOne,
        ScoreEnum.TwoTwo,
        ScoreEnum.ThreeThree,
        ScoreEnum.FourFour,
        ScoreEnum.FiveFiveMore,
      ]
  }
}

export interface CreatePredictionData {
  winner: string | null
  predictedScore: string
  roomId: string
  matchId: string
  /** Playoff: predicted winner in extra time (team name). */
  predictedWinnerAdditionalTime?: string | null
  /** Playoff: predicted winner on penalties (team name). */
  predictedWinnerPenalties?: string | null
}

export interface UpdatePredictionData {
  winner: string | null
  predictedScore: string
  predictedWinnerAdditionalTime?: string | null
  predictedWinnerPenalties?: string | null
}
